import { useRef, useEffect } from "react";
import "../styles/pages/catalogue.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { Button, Container, Typography } from "@mui/material";
import Image from "../../Utils/getImage";
import { useNavigate } from "react-router-dom";

const Catalogue = ({ data }) => {
  const navigate = useNavigate();
  const swiperRef = useRef(null);

  const addCustomClasses = () => {
    const swiper = swiperRef.current?.swiper;
    if (!swiper || !swiper.slides || swiper.slides.length === 0) return;

    swiper.slides.forEach((slide) => {
      slide.classList.remove(
        "swiper-slide-prev-prev",
        "swiper-slide-next-next"
      );
    });

    const totalSlides = swiper.slides.length;
    const currentIndex = swiper.realIndex;

    const prevPrevIndex = (currentIndex - 2 + totalSlides) % totalSlides;
    const nextNextIndex = (currentIndex + 2) % totalSlides;

    swiper.slides[prevPrevIndex]?.classList.add("swiper-slide-prev-prev");
    swiper.slides[nextNextIndex]?.classList.add("swiper-slide-next-next");
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      addCustomClasses();
    }, 100);
    return () => clearTimeout(timer);
  }, [data]);

  return (
    <section className="catalogue-section">
      <Container maxWidth="xl">
        {data && data.length > 0 ? (
          <div className="skewed-carousel-container">
            <Swiper
              ref={swiperRef}
              grabCursor={true}
              // loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: true,
              }}
              slidesPerView={5}
              spaceBetween={-100}
              centeredSlides={true}
              initialSlide={2}
              modules={[Autoplay, Navigation]}
              navigation={true}
              className="skewed-swiper"
              onSlideChange={addCustomClasses}
              onSwiper={addCustomClasses}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: -40,
                  centeredSlides: false,
                },
                640: {
                  slidesPerView: 2.5,
                  spaceBetween: -60,
                  centeredSlides: true,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: -80,
                  centeredSlides: true,
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: -90,
                  centeredSlides: true,
                },
                1440: {
                  slidesPerView: 5,
                  spaceBetween: -100,
                  centeredSlides: true,
                },
              }}
            >
              {data?.map((catalogue, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="skewed-slide"
                    onClick={() => navigate(`/product/${catalogue?._id}`)}
                  >
                    <div className="slide-content">
                      <Image
                        src={
                          catalogue?.picture
                            ? catalogue?.picture[0]
                            : catalogue.image
                        }
                        alt={`catalogue_image_${index}`}
                        height={170}
                        width={"100%"}
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          <Typography
            variant="h6"
            align="center"
            sx={{ padding: "50px 0", color: "#777" }}
          >
            No catalogue available
          </Typography>
        )}
      </Container>
    </section>
  );
};

export default Catalogue;
